<template>
    <print-layout>
        <div class="print-container">
            <div v-for="(order, index) in orders" :key="index">
                <heading-info
                    :order="order"
                    :type="'invoice'"
                />

                <order-list 
                    :order="order"
                    :type="'invoice'"
                />

                <div class="text-xs mt-4">
                    HST # {{ hst }}
                </div>

                <div class="text-sm mt-2">
                    Thank you for your order!
                    Please note all credits must be reported to sales@fresherproduce.ca within <b>the same day</b> of receiving your order.
                    Our customer care team will arrange pick up, and all credits will be issued once it arrives back to our warehouse upon inspection.
                </div>

                <div class="page-break"></div>
            </div>

        </div>

        <div v-if="!orders.length" class="p-2 mx-auto max-w-xl">
            Something went wrong. There are no orders to print, please try again.
        </div>
    </print-layout>
</template>

<script>
import PrintLayout from '@/Layouts/PrintLayout.vue';
import HeadingInfo from '@/Pages/Orders/Prints/Partials/HeadingInfo.vue';
import OrderList from '@/Pages/Orders/Prints/Partials/OrderList.vue';
import UseUserAuth from '@/Composables/UseUserAuth';
import { DateTime } from "luxon";
import { usePage } from '@inertiajs/inertia-vue3';
import { computeOrderTotals } from '@/Composables/useOrderTotals';

export default {
    setup () {
        const { isAdmin } = UseUserAuth(usePage().props.value.user);

        return {
            isAdmin,
        }
    },

    components: {
        PrintLayout,
        HeadingInfo,
        OrderList,
    },

    props: ['orders', 'hst'],

    methods: {
        formatDate(date)
        {
            return DateTime.fromISO(date).toFormat('MMM d, yyyy');
        },

        subtotal (order) {
            return computeOrderTotals(order).subtotal;
        },
        tax(order) {
            return computeOrderTotals(order).tax;
        },
        total (order) {
            return computeOrderTotals(order).total;
        },
        delivery_fee (order) {
            return computeOrderTotals(order).deliveryFeeAfterDiscount;
        }
    },

    mounted () {
        if (route().params.download === undefined && this.orders.length) {
            window.print();

            window.onafterprint = function() {
                window.close();
            };
        }
    }
}

</script>

<style>
    body {
        font-size: 90%;
        height: 100%;
    }

    table {
        width: 100%;
    }

    table td {
        -webkit-print-color-adjust: exact;
    }

    .page-break {
        page-break-after: always;
    }

    .subheader th {
        background: #cbcbcb;
        -webkit-print-color-adjust: exact;
    }

    .signature {
        @apply border-r-0 border-l-0 border-t-0 border-b border-gray-dark !important;
    }

    .footer {
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100%;
    }

    @media screen {
        .print-container {
            display: none;
        }
    }

    .striped tr:nth-child(even):not(.not_striped) {
        background-color: #f2f2f2;
    }
</style>
